export const CNewsletterEmailStashKey = 'stashed_newsletterEmail';
